import * as React from 'react';

const PMLogoIcon = () => {
	return (
		<svg width='203' height='18' viewBox='0 0 203 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_80_985)'>
				<path
					d='M33.7101 0.0595703L21.3501 17.9396H29.4001L31.0901 15.2296H38.9101L39.1901 17.9396H46.9001L44.4101 0.0595703H33.7101ZM34.0701 10.4796L37.6201 4.80957H37.7701L38.3801 10.4796H34.0601H34.0701Z'
					fill='#F8FF13'
				/>
				<path
					d='M194.43 0.0595703L193.05 6.28957H186.18L187.56 0.0595703H179.74L175.76 17.9396H183.57L184.9 11.9596H191.77L190.44 17.9396H198.26L202.25 0.0595703H194.43Z'
					fill='#F8FF13'
				/>
				<path
					d='M163.36 9.1498C163.36 7.1298 164.84 6.0298 167.58 6.0298H176.25L177.73 0.0498047H166.4C160.04 0.0498047 155.72 3.9098 155.72 9.6298C155.72 14.7098 159.48 17.9298 165.45 17.9298H173.97L175.45 11.9498H166.88C164.58 11.9498 163.35 10.9798 163.35 9.1398L163.36 9.1498Z'
					fill='#F8FF13'
				/>
				<path
					d='M26.22 5.90957C26.22 1.12957 21.22 0.0595703 18.4 0.0595703H4.74L0.75 17.9396H8.57L9.49 13.7996H16.95C22.85 13.7996 26.22 9.96957 26.22 5.90957ZM15.16 8.91957H10.59L11.36 5.38957H16.14C17.72 5.38957 18.44 5.87957 18.44 6.89957C18.44 8.22957 17.29 8.91957 15.17 8.91957H15.16Z'
					fill='#F8FF13'
				/>
				<path d='M75.8098 0.0595703L71.8198 17.9396H79.6398L83.6298 0.0595703H75.8098Z' fill='#F8FF13' />
				<path
					d='M103.35 0.0595703L98.01 8.68957H97.83L96.02 0.0595703H86L82.02 17.9396H89.83L91.8 7.82957H91.88L94 17.9396H98.32L104.83 7.82957H104.96L102.4 17.9396H110.22L114.21 0.0595703H103.35Z'
					fill='#F8FF13'
				/>
				<path
					d='M135.77 0.0595703L134.44 6.00957H141.62L138.96 17.9396H146.78L149.43 6.00957H155.05L157.99 0.0595703H135.77Z'
					fill='#F8FF13'
				/>
				<path
					d='M121.54 0.0595703L111.04 17.9396H119.09L120.49 15.2296H128.31L128.87 17.9396H136.58L132.24 0.0595703H121.54ZM122.97 10.4796L125.93 4.80957H126.08L127.28 10.4796H122.96H122.97Z'
					fill='#F8FF13'
				/>
				<path
					d='M73.1499 5.52957C73.1499 2.05957 70.2899 0.0595703 65.3099 0.0595703H51.6399L47.6499 17.9396H55.4699L56.8499 11.7796H56.9499L61.7999 17.9396H70.9999L66.3499 12.8596V12.7296C70.4099 11.9896 73.1499 9.19957 73.1499 5.52957ZM62.2699 8.48957H57.5699L58.3099 5.21957H63.0599C64.6999 5.21957 65.3799 5.64957 65.3799 6.59957C65.3799 7.87957 64.3799 8.48957 62.2599 8.48957H62.2699Z'
					fill='#F8FF13'
				/>
			</g>
			<defs>
				<clipPath id='clip0_80_985'>
					<rect width='202' height='18' fill='white' transform='translate(0.5)' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default PMLogoIcon;
